<template>
  <Content>
    <FlexContainer>
      <FlexItem :grow="true" padding="normal">
        <Card
          ><AccountIcon />
          <p>You are logged in as {{ currentUser.name }}</p>
          <ButtonLink type="tertiary" fullWidth="true" @click.native="signOut">
            Logout
          </ButtonLink></Card
        >
      </FlexItem>
    </FlexContainer>
  </Content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AccountIcon from '@/components/account/AccountIcon';

export default {
  components: {
    AccountIcon
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser
    })
  },
  methods: {
    ...mapActions({
      signOut: 'user/signOut'
    })
  }
};
</script>

<style lang="scss" scoped>
.account {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: $padding-large;
  padding-bottom: $padding-largest;
  min-height: 50vh;
}
</style>
